function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M78.5 36.2985H49V66.2985H19V96.7985H49V124.298H78.5V96.7985H106.5V66.2985H78.5V36.2985Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M97 14.2985L169 35.2985C179 38.7985 182.5 50.7985 181.5 55.2985C180.7 58.8985 157.5 136.799 146 175.299C144.5 180.799 133 187.799 126 185.299C120.4 183.299 74.3333 170.132 52 163.799C46.5 161.799 39.5 149.299 41 143.799L43.0475 136.974C44.8539 137.823 46.8715 138.298 49 138.298H78.5C86.232 138.298 92.5 132.03 92.5 124.298V110.798H106.5C114.232 110.798 120.5 104.53 120.5 96.7985V66.2985C120.5 58.5665 114.232 52.2985 106.5 52.2985H92.5V36.2985C92.5 28.5665 86.232 22.2985 78.5 22.2985H77.6161C80.6459 16.9829 91.9653 12.83 97 14.2985ZM49 117.132L73.25 36.2985H78.5V66.2985H106.5V96.7985H78.5V124.298H49V117.132Z",
  fill: "currentColor"
});

function SvgHazard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazard);
export default __webpack_public_path__ + "static/media/hazard.b071f81d.svg";
export { ForwardRef as ReactComponent };